import { render, staticRenderFns } from "./SmartSearchbarAutocompleteSuggestion.vue?vue&type=template&id=4899eedc&"
import script from "./SmartSearchbarAutocompleteSuggestion.vue?vue&type=script&lang=ts&"
export * from "./SmartSearchbarAutocompleteSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports